import $ from 'jquery';
import axios from 'axios';
import React, { Component } from 'react';
import uuidv1 from 'uuid/v1';
import JSZip, { forEach } from 'jszip';
import JSZipUtils from 'jszip-utils';
import { DamService } from '../../services/dam';
import { UserService } from '../../services/user';
import { WorkflowsService } from '../../services/workflows';
import { xmlBuilder } from '../../services/xml';

import { Compositions } from '../../containers';
import { RDP_TRANSLATE } from '../../translate/translate';
import RDP_CONFIG from '../../config';
import { Configurations, ElementEdit, ElementMessages, ElementActivities, Popup, Sidebar } from '../../components';
import replaceCompositionObjectsIds from "../../utils/replaceCompositionObjectsIds";
import Swal from 'sweetalert2';
import Url from "../../utils/url";
import getConnectorFromArray from "../../utils/getConnectorFromArray";
import { getTheme } from '../../utils/getTheme';
import { StructureProvider } from '../../hooks/context/structure';
import { CompositionProvider } from '../../hooks/context/composition';
import { ActionsMenu } from '../../components/actions-menu';
import { createObjectTable } from '../../utils/table';
import {
    RDPDamWidget, ColorPicker
} from '../../components';
import ElementAudioBook from '../../elements/element-audiobook/element-audiobook';
import './audiobook.css';

export default class ViewAudiobook extends Component {

    constructor(props) {
        super(props);

        this.iaQuizContentInput = React.createRef();
        this.iaQuizContentTextarea = React.createRef();

        this.state = {
            "audiobook": {
                "title": "",
                "author": "",
                "duration": 0,
                "thumb": "",
                "size": 0,
                "chapters": [],
            },
            "is_embed": this.props.match.path.search("/embed/") !== -1,
            "downloading": false,
            "opened_configurations": false,
            "opened_menu": false,
            "opened_help": false,
            "displayed_preloader": this.props.match.params.content_uid !== undefined,
            "structure": [],
            "enabled_element_edit_props": false,
            "enabled_element_message_object_uid": null,
            "redirect_to_preview": false,
            "redirect_to_home": false,
            "mirror_composition": null,
            "composition_backup": {},
            "composition": {
                "version": "1.1",
                "metadata": {
                    "title": "Sem título",
                    "description": "",
                    "thumb": null,
                    "tags": []
                },
                "interface": {
                    "content_language": RDP_CONFIG.language,
                    "index_option": "buttons",
                    "font_family": "Lato",
                    "show_summary": "disabled",
                    "finish_btn": "disabled"
                },
                "structure": []
            },
            "labels": RDP_TRANSLATE[RDP_CONFIG.language]().audiobook,
            "google_fonts_render_modal": false,
            "google_fonts": null,
            "ia_render_text_modal": false,
            "ia_render_text_modal_preloader": false,
            "ia_element": null,
            "ia_index": null,
            "ia_render_quiz_modal": false,
            "ia_quiz_questions_length": 1,
            "ia_quiz_question_context": "composition",
            "ia_render_quiz_modal_preloader": false,
            "project_users": null,
            "render_versions_history": false,
            "first_version": null,
            "render_first_version_items": false,
            "second_version": null,
            "render_second_version_items": false,
            "versions": [],
            "can_send_object_messages": false,
            "render_activities": false,
            "can_edit_composition": true,
            "can_edit_video": true,
            "can_edit_audio": true,
            "can_edit_text": true,
            "can_edit_image": true,
            "render_composition_processes": false,
            "temp_processes_selected_first": null,
            "temp_processes_selected_last": null,
            "processes_selected_first": null,
            "processes_selected_last": null,
            "enabled_workflows": false,
            "structure_before_removed": null,
            "dam_widget_thumb_opened": false,
            "dam_widget_audio_opened": false,
            "current_edit_chapter": null,
            "audio_url": null,
            "audio_uid": "audio-player",
            "active_mode": "edit",
            "is_saving": false,
            "show_loader": true,
            "loader_text": "Carregando...",
            "zip_file": null,
            "manifest": null,
        }

        this.onTitleChange = this.onTitleChange.bind(this);
        this.onAuthorsChange = this.onAuthorsChange.bind(this);
        this.onChapterTitleChange = this.onChapterTitleChange.bind(this);
        this.onCoverImageClick = this.onCoverImageClick.bind(this);
        this.onChapterAudioSelect = this.onChapterAudioSelect.bind(this);
        this.onAudioLoaded = this.onAudioLoaded.bind(this);
        this.onSaveButtonClick = this.onSaveButtonClick.bind(this);
    }

    componentWillMount() {
        if (this.props.match.params.content_uid !== undefined) {
            // this.getUserRestrictions();
            this.getProcesses();
            this.dispatchConnectorStatusWorkflow()
            this.getContent();
        }
        else
        {
            const manifest = this.getManifestStructure();
            this.setState({
                "manifest": manifest,
                "show_loader": false,
            })
        }
        // this.redirectToLogin();
    }

    dispatchConnectorStatusWorkflow() {
        var enabledWorkflows = false;
        var connectors = UserService.getAllConnectors();
        for (var i = 0; i < connectors.length; i++) {
            var configuration = JSON.parse(connectors[i].configuration);
            if (configuration.name === "Workflow") {
                enabledWorkflows = true;
            };
        };

        this.setState({
            "enabled_workflows": enabledWorkflows
        });
    }

    hasConnectorWorflow() {
        var enabledWorkflows = false;
        var connectors = UserService.getAllConnectors();
        for (var i = 0; i < connectors.length; i++) {
            var configuration = JSON.parse(connectors[i].configuration);
            if (configuration.name === "Workflow") {
                enabledWorkflows = true;
            };
        };

        return enabledWorkflows;
    }

    async getProcesses() {
        if (this.hasConnectorWorflow()) {
            var processes = await WorkflowsService.getProcesses();
            console.log(processes)
            this.setState({
                "processes": processes
            });
        }
    }

    async onSaveButtonClick() {
        const text = this.state.labels.loader_saving;
        var {manifest} = this.state;
        const {audiobook} = this.state;
        this.setState({
            "is_saving": true,
            "show_loader": true,
            "loader_text": text,
        });
        var _this = this;
        // var manifest = this.getManifestStructure();
        manifest.metadata.title = _this.state.audiobook.title;
        manifest.audiobook = _this.state.audiobook;
        manifest.uid = uuidv1();
        manifest.created_at = this.generateCustomDateString()

        var assets = []
        for(var i = 0; i < manifest.assets.length; i++) {
            if(manifest.assets[i].uid === audiobook.thumb || audiobook.chapters.find(x => x.asset === manifest.assets[i].uid)) {
                assets.push(manifest.assets[i]);
            }
        }
        manifest.assets = assets;

        var zip = new JSZip();
        zip.file("manifest.json", JSON.stringify(manifest));
        
        if (audiobook.thumb) {
            const image_asset = manifest.assets.find(x => x.uid === audiobook.thumb);
            await this.saveAsset(image_asset, zip);
        }
        
        for(var i = 0; i < audiobook.chapters.length; i++) {
            const audio_asset = manifest.assets.find(x => x.uid === audiobook.chapters[i].asset);
            await this.saveAsset(audio_asset, zip);  
        }
        // console.log(zip);

        zip.generateAsync({
            type: "blob",
            mimeType: "digitalpages/audiobook",
        }).then(async function (content) {
            // console.log(content)
            const uid = _this.props.match.params.content_uid;
            if (uid)
                await _this.updateContent(manifest.metadata.title, content);
            else
                await _this.saveContent(manifest.metadata.title, content);

            _this.setState({
                "zip_file": zip,
            })
        });

    }

    async saveAsset(asset, zip) {
        var assets = zip.folder("assets");

        const fileName = asset.name;
        // const fileExtension = fileName.substring(fileName.lastIndexOf(".") + 1);
        const file_data = await DamService.getContentZip(asset.uid, UserService.getUser().access_token);
        // console.log(file_data);
        assets.file(`${fileName}`, file_data);
    }

    getManifestStructure() {
        return {
            "metadata": {
                "title": ""
            },
            "audiobook": {},
            "assets": [],
        };
    }

    generateCustomDateString() {
        const date = new Date();

        // Obtém a data no formato ISO padrão
        let isoString = date.toISOString(); // Exemplo: "2024-12-18T13:58:38.667Z"

        // Adiciona mais precisão de nanossegundos (fictício, pois JavaScript não suporta além de milissegundos)
        const nanoPrecision = date.getMilliseconds() + '3599';

        // Substitui "Z" pelo sufixo desejado
        isoString = isoString.replace(/\.\d{3}Z$/, `.${nanoPrecision}`);
        return isoString;
    }

    async saveContent(name, content) {
        var _this = this;
        const config = RDP_CONFIG;

        var fd = new FormData();
        var files = this.getTemplateFile(name, content);
        var connectorUid = UserService.getActiveProject().connectors[0].uid;
        var userData = UserService.getUser();
        var type = userData.type;
        const accessToken = UserService.getUser().access_token;

        fd.append('file', files, `${name}.bundle`);
        fd.append("content_info", `file_name=${name}`);
        fd.append("content_info", `title=${this.state.audiobook.title}`);

        $.ajax({
            url: `https://${config.domain}/storage/${config.apiVersion}/upload/connector/uid/${connectorUid}`,
            type: "POST",
            data: fd,
            contentType: false,
            processData: false,
            headers: {
                "Authorization": type + " " + accessToken,
                "Project-Key": config.projectKey,
                "Api-Env": config.enviroment
            },
            success: function (response) {
                var uid = response[0].document.content_uid;
                var contentTags = [];
                var contentFilters = {};
                var contentInfo = {};
                contentInfo.file_name = name;

                // DamService.updateFile(contentTags, contentInfo, contentFilters, uid, type, accessToken).then(function (data) {
                //     console.log(data)
                // });

                // var newId = response[0].uid;
                _this.redirectToAudiobook(uid);


            },
            error: function (response) {
                console.log(response)
                _this.setState({
                    "show_loader": false,
                })
            }
        });
    }

    updateContent(name, content) {
        // console.log("Update");
        var _this = this;
        const config = RDP_CONFIG;

        var fd = new FormData();
        var files = this.getTemplateFile(name, content);
        const projectUid = UserService.getActiveProject().uid;
        const uid = this.props.match.params.content_uid;
        var userData = UserService.getUser();
        var type = userData.type;
        const accessToken = UserService.getUser().access_token;

        fd.append('file', files, `${name}.bundle`);
        fd.append("content_info", `file_name=${name}`);
        fd.append("content_info", `title=${this.state.audiobook.title}`);

        $.ajax({
            url: `https://${config.domain}/storage/${config.apiVersion}/content?uid=${uid}&manual_project_uid=${projectUid}`,
            type: "PUT",
            data: fd,
            contentType: false,
            processData: false,
            headers: {
                "Authorization": type + " " + accessToken,
                "Project-Key": config.projectKey,
                "Api-Env": config.enviroment
            },
            success: function (response) {
                var uid = response[0].document.content_uid;
                var contentTags = [];
                var contentFilters = {};
                var contentInfo = {};
                contentInfo.file_name = name;
                contentInfo.title = _this.state.audiobook.title;

                // DamService.updateFile(contentTags, contentInfo, contentFilters, uid, type, accessToken).then(function (data) {
                //     console.log(data)
                // });

                // var newId = response[0].uid;
                // console.log("updated");
                // console.log(uid)
                _this.redirectToAudiobook(uid);


            },
            error: function (response) {
                console.log(response)
                _this.setState({
                    "show_loader": false,
                })
            }
        });
    }

    blobToFile(theBlob, fileName) {
        theBlob.lastModifiedDate = new Date();
        theBlob.name = fileName;
        return theBlob;
    }

    getTemplateFile(name, myBlob) {
        return this.blobToFile(myBlob, `${name}.rdpbundle`);
    }

    async getContent() {
        var uid = this.props.match.params.content_uid;
        if (!uid)
        {
            return;
        }

        try {
            const accessToken = UserService.getUser().access_token;
            var content = await DamService.getContentZip(uid, accessToken);
            var audiobook = await this.getAudiobookFromBlob(content);
            const zip = await JSZip.loadAsync(content);     
            const manifest = await zip.file("manifest.json").async("string");       

            this.setState({
                "audiobook": audiobook,
                "zip_file": zip,
                "show_loader": false,
                "manifest": JSON.parse(manifest),	
            })

        } catch (error) {
            console.log(error);
            this.redirectToAudiobook("");
        }
    }

    async getAudiobookFromBlob(content) {
        
        var zip = await JSZip.loadAsync(content);
        var manifest = await zip.file("manifest.json").async("string");
        var manifestParsed = JSON.parse(manifest)

        // console.log(manifestParsed)

        this.setState({
            "zip_file": zip,
            "manifest": manifestParsed,
        });

        return manifestParsed.audiobook;
    }

    onSelectMode(mode) {

        this.setState({
            "render_initial_frame": true,
            "active_mode": mode
        })
    }

    redirectToHome() {
        var path = this.state.is_embed ? "/embed/" : "/";
        window.location = window.location.origin + window.location.pathname + "#" + path;
    }

    redirectToAudiobook(id) {
        var path = this.state.is_embed ? "/embed/" : "/";
        window.location = window.location.origin + window.location.pathname + "#" + path + `audiobook/${id}`;
    }

    onImageAssetChange(asset, data) {
        var {manifest} = this.state;
        var audiobook = this.state.audiobook;
        // audiobook.thumb = asset;
        
        if(audiobook.thumb)
            manifest.assets = manifest.assets.filter(x => x.uid !== audiobook.thumb);
        
        audiobook.thumb = data.uid;
        manifest.assets.push({
            "uid": data.uid,
            "name":this.formatFileName(data.file_name),
            "content_type": data.content_type,
        })

        this.setState({
            "dam_widget_thumb_opened": false,
            "audiobook": audiobook,
            "manifest": manifest,
        })
    }

    formatFileName(fileName) {
        fileName = fileName.replaceAll(" ", "-");
        return fileName.normalize("NFD").replaceAll(/[\u0300-\u036f]/g, "");
    }


    onAudioAssetChange(asset, data) {
        const audioplayer = document.querySelector(`#${this.state.audio_uid}`);
        audioplayer.setAttribute('src', this.getFilePath(data.uid));
        audioplayer.play()
        var audiobook = this.state.audiobook;

        var { manifest } = this.state;

        if(audiobook.chapters[this.state.current_edit_chapter].asset)
            manifest.assets = manifest.assets.filter(x => x.uid !== audiobook.chapters[this.state.current_edit_chapter].asset);

        audiobook.chapters[this.state.current_edit_chapter].audioUrl = asset;
        audiobook.chapters[this.state.current_edit_chapter].size = data.content_size;
        audiobook.chapters[this.state.current_edit_chapter].asset = data.uid;

        manifest.assets.push({
            "uid": data.uid,
            "name":this.formatFileName(data.file_name),
            "content_type": data.content_type,
        })

        var total = 0;
        for (var i = 0; i < audiobook.chapters.length; i++) {
            total += audiobook.chapters[i].size;
        }
        audiobook.size = total;

        const text = this.state.labels.loader_loading;

        this.setState({
            "dam_widget_audio_opened": false,
            "audiobook": audiobook,
            "show_loader": true,
            "loader_text": text,
            "manifest": manifest,
        })
    }

    onRDPDamWidgetClose() {
        this.setState({
            "dam_widget_thumb_opened": false,
            "dam_widget_audio_opened": false,
        })

    }

    renderDAMWidgetThumb() {
        if (this.state.dam_widget_thumb_opened === true) {
            return <RDPDamWidget
                labels={this.props.labels}
                type="image"
                onClose={() => this.onRDPDamWidgetClose()}
                onAssetChange={(asset, data) => this.onImageAssetChange(asset, data)}
            />;
        }
    }

    renderDAMWidgetAudio() {
        if (this.state.dam_widget_audio_opened === true) {
            return <RDPDamWidget
                labels={this.props.labels}
                type="audio"
                onClose={() => this.onRDPDamWidgetClose()}
                onAssetChange={(asset, data) => this.onAudioAssetChange(asset, data)}
            />;
        }
    }

    onCoverImageClick() {
        this.setState({
            "dam_widget_thumb_opened": true,
        }
        )
    }

    onChapterAudioSelect(index) {
        this.setState({
            "current_edit_chapter": index,
            "dam_widget_audio_opened": true,
        }
        )
    }

    onAudioLoaded(event) {
        const audioplayer = document.querySelector(`#${this.state.audio_uid}`);
        var audiobook = this.state.audiobook;

        audiobook.chapters[this.state.current_edit_chapter].duration = audioplayer.duration;

        var total = 0;
        for (var i = 0; i < audiobook.chapters.length; i++) {
            total += audiobook.chapters[i].duration;
        }
        audiobook.duration = total;

        this.setState({
            "current_edit_chapter": -1,
            "audiobook": audiobook,
            "show_loader": false,
        }
        )
    }

    onTitleChange(e) {
        e.preventDefault();
        e.stopPropagation();

        var title = e.target.value;
        var audiobook = this.state.audiobook;

        audiobook.title = title;

        this.setState({
            "audiobook": audiobook
        });
    }

    onAuthorsChange(e) {
        e.preventDefault();
        e.stopPropagation();

        var author = e.target.value;
        var audiobook = this.state.audiobook;

        audiobook.author = author;

        this.setState({
            "audiobook": audiobook
        });
    }

    onChapterTitleChange(e, index) {
        e.preventDefault();
        e.stopPropagation();

        var title = e.target.value;
        var audiobook = this.state.audiobook;
        var chapter = audiobook.chapters[index];
        chapter.title = title;

        this.setState({
            "audiobook": audiobook
        });
    }

    getCoverImage(image) {
        if (!image)
            return image;
        const accessToken = UserService.getUser().access_token;
        // return `${image}&access_token=${accessToken}`;
        return this.getFilePath(image);
    }

    getFilePath(fileUid) {
        var config = RDP_CONFIG;
        const accessToken = UserService.getUser().access_token;
        const path = `https://${config.domain}/storage/${config.apiVersion}/content?uid=${fileUid}&project_key=${config.projectKey}&api_env=${config.apiEnv}&access_token=${accessToken}`
        return path;
    }

    getFormattedTime(timespan) {
        var minutes = parseInt(timespan / 60);
        var seconds = (timespan % 60);

        let min = minutes.toLocaleString('en-US', {
            minimumIntegerDigits: 2
        })
        let sec = seconds.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            maximumFractionDigits: 0
        })

        return `${min}:${sec}`;
    }

    getFormattedSize(size) {
        return this.sizeOf(size);
    }

    sizeOf(bytes) {
        if (bytes === 0) { return "0.00 MB"; }
        var e = Math.floor(Math.log(bytes) / Math.log(1024));
        return (bytes / Math.pow(1024, e)).toFixed(2) + ' ' + ' KMGTP'.charAt(e) + 'B';
    }

    addChapter() {
        var audiobook = this.state.audiobook;
        var chapters = audiobook.chapters;
        chapters.push(
            {
                uid: uuidv1(),
                title: "",
                description: "",
                author: "",
                audioUrl: "",
                duration: 0,
                size: 0,
                asset: "",
            },
        );

        this.setState({
            "audiobook": audiobook
        });
    }

    removeChapter(index) {
        var audiobook = this.state.audiobook;
        var chapters = audiobook.chapters;
        var manifest = this.state.manifest;

        var chapter = chapters[index];
        manifest.assets = manifest.assets.filter(x => x.uid !== chapter.asset);

        chapters.splice(index, 1);

        this.setState({
            "audiobook": audiobook,
            "manifest": manifest,
        });
    }

    moveChapter(curIndex, increment) {
        var audiobook = this.state.audiobook;
        var chapters = audiobook.chapters;
        if (curIndex + increment < 0 || curIndex + increment > chapters.length - 1)
            return;

        var element = chapters[curIndex];
        chapters.splice(curIndex, 1);
        chapters.splice(curIndex + increment, 0, element);

        this.setState({
            "audiobook": audiobook
        });
    }


    renderEditor() {
        return (
            <div className="form-container">
                <div className="section">

                    <h3 className="section-title">{this.state.labels.body_title}</h3>
                    <div className="form-group">
                        <label htmlFor="titulo">{this.state.labels.title}</label>
                        <input type="text" id="titulo" name="titulo" placeholder='Título' value={`${this.state.audiobook.title}`} onChange={(value) => { this.onTitleChange(value) }} />
                    </div>
                    <div className="form-row">
                        <div className="form-col">
                            <div className="form-group">
                                <label htmlFor="tempo_total">{this.state.labels.total_time}</label>
                                <input type="text" id="tempo_total" name="tempo_total" disabled value={`${this.getFormattedTime(this.state.audiobook.duration)}`} />
                                <div className="auto-update">{this.state.labels.update_info}</div>
                            </div>
                        </div>
                        <div className="form-col">
                            <div className="form-group">
                                <label htmlFor="tamanho_total">{this.state.labels.total_size}</label>
                                <input type="text" id="tamanho_total" name="tamanho_total" disabled value={`${this.getFormattedSize(this.state.audiobook.size)}`} />
                                <div className="auto-update">{this.state.labels.update_info}</div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="autores">{this.state.labels.authors}</label>
                        <input type="text" id="autores" name="autores" value={`${this.state.audiobook.author}`} onChange={(value) => { this.onAuthorsChange(value) }} />
                    </div>
                    <h3 className="section-title" style={{ margin: '20px 0' }}>{this.state.labels.cover_title}</h3>
                    <div className="form-row">
                        <div className="form-col">
                            <div className="preview-image" style={{ backgroundImage: `url(${this.getCoverImage(this.state.audiobook.thumb)})`, backgroundColor: this.state.audiobook.thumb ? '' : `#aaa`, color: this.state.audiobook.thumb === "" ? '' : `#eee` }} onClick={() => this.onCoverImageClick(this.state.audiobook.thumb)}>
                                <div className={`preview-image-text ${this.state.audiobook.thumb !== "" ? 'disabled' : ""}`}>{this.state.labels.image_select}</div>
                            </div>
                        </div>
                        <div className="form-col"></div>
                    </div>
                </div>

                <div className="section">
                    <h3 className="section-title">{this.state.labels.chapters}</h3>
                    <button className="button-add" id="addChapter" onClick={() => this.addChapter()}>+ {this.state.labels.add_chapter_button}</button>
                    <audio id={this.state.audio_uid} muted autoPlay style={{ display: "none" }} onLoadedMetadata={this.onAudioLoaded} />

                    <div id="chaptersContainer">
                        {this.state.audiobook.chapters &&
                            this.state.audiobook.chapters.map((chapter, index) => {
                                return <div key={index} className='chapter-container'>
                                    <div className="chapter-header">
                                        <span className="chapter-number">{`Capítulo ${index + 1}`}</span>
                                        <div className="chapter-actions">
                                            <button className="move-button move-up" title="Mover para cima" onClick={() => this.moveChapter(index, -1)}>↑</button>
                                            <button className="move-button move-down" title="Mover para baixo" onClick={() => this.moveChapter(index, 1)}>↓</button>
                                            <button className="remove-chapter" title="Remover capítulo" onClick={() => this.removeChapter(index)}>×</button>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor={`capitulo_titulo_${index}`}>Título</label>
                                        <input type="text" id={`capitulo_titulo_${index}`} name={`capitulo_titulo_${index}`} value={`${chapter.title}`} onChange={(value) => { this.onChapterTitleChange(value, index) }} />
                                    </div>
                                    <div className="file-upload">
                                        <div className="file-icon">♫</div>
                                        <div>{chapter.file || this.state.labels.audio_file}</div>
                                        <button className="download-button" onClick={() => this.onChapterAudioSelect(index)}>↓</button>

                                    </div>
                                    <div className="file-info">
                                        <div>{`${this.state.labels.audio_time}: ${this.getFormattedTime(chapter.duration)}` || '00:00'}</div>
                                        <div>{`${this.state.labels.audio_size}: ${this.getFormattedSize(chapter.size)}` || '0 MB'}</div>
                                    </div>
                                </div>
                            })
                        }
                    </div>
                </div>

                <div className="form-footer">
                    <button className={`save-button ${this.state.is_saving ? "disabled" : ""}`} disabled={this.state.is_saving} onClick={() => this.onSaveButtonClick()}>{this.state.labels.save_button}</button>
                </div>
            </div>
        )
    }

    renderPreview() {
        return (
            <ElementAudioBook book={this.state.audiobook} />
        )
    }

    renderLoader() {
        if (this.state.show_loader) {
            return (
                <div className='loader-wrapper'>
                    <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                    <p>{this.state.loader_text}</p>
                </div>
            )
        }
    }

    render() {
        const {
            versions,
            processes,
            temp_processes_selected_first,
            temp_processes_selected_last
        } = this.state;
        var _this = this;
        let { headerActionsTemplate, footerActionsTemplate, content, editable } = this.props;
        return (
            <div className="container">
                {this.renderLoader()}
                <div className="audiobook-header">
                    {/* <button className="back-button" onClick={() => this.redirectToHome()}>←</button> */}
                    {this.props.isEmbed &&
                        <span onClick={() => this.redirectToHome()} className="rdp-audiobook-header-preview-back-embed">Voltar</span>
                    }
                    {!this.props.isEmbed &&
                        <span onClick={() => this.redirectToHome()} className="rdp-audiobook-header-preview-back">Voltar</span>
                    }
                    <h1>{this.state.labels.header_title}</h1>
                    {/* <button className="settings-btn">⚙</button> */}
                </div>

                {/* {editable && */}
                <ul className="element-video-interactive-1-mode-btns">
                    <li className={`element-video-interactive-1-mode-btn ${this.state.active_mode === "preview" ? "active" : ""}`} onClick={() => this.onSelectMode("preview")}>
                        <span className="element-video-interactive-1-mode-btn-icon play"></span>
                        <span className="element-video-interactive-1-mode-btn-label">Modo Preview</span>
                    </li>
                    <li className={`element-video-interactive-1-mode-btn ${this.state.active_mode === "edit" ? "active" : ""}`} onClick={() => this.onSelectMode("edit")}>
                        <span className="element-video-interactive-1-mode-btn-icon edit"></span>
                        <span className="element-video-interactive-1-mode-btn-label">Modo Edição</span>
                    </li>
                    {/* <li className={`element-video-interactive-1-mode-btn ${this.state.active_mode === "json" ? "active" : ""}`} onClick={() => this.onSelectMode("json")}>
                            <span className="element-video-interactive-1-mode-btn-icon json"></span>
                            <span className="element-video-interactive-1-mode-btn-label">Modo JSON</span>
                        </li> */}
                </ul>
                {/* } */}

                {this.state.active_mode === "edit" && this.renderEditor()}
                {this.state.active_mode === "preview" && this.renderPreview()}

                {this.renderDAMWidgetThumb()}
                {this.renderDAMWidgetAudio()}
            </div>
        );
    }
}